module.exports = __webpack_public_path__ + "static/media/image-card-5.a7a49e13.png";